import Avatar from './Avatar';
export default Avatar;



// WEBPACK FOOTER //
// ./src/js/Avatars/index.js